import { createContext, useContext, useState } from "react";

export const SellerPageContext = createContext(null);

export function SellerPageContextProvider({ children }) {

    const [account, setAccount] = useState(null)
    const [events, setEvents] = useState([])
    const [subscriptions, setSubscriptions] = useState([])
    const [endUser, setEndUser] = useState(null)
    const [purchasedSubscriptions, setPurchasedSubscriptions] = useState([])
    const [purchasedEvents, setPurchasedEvents] = useState([])
    const [triggerEndUserDataFetch, setTriggerEndUserDataFetch] = useState(null)
    const [fetchingEndUserData, setFetchingEndUserData] = useState(false)
    const [entryPasses, setEntryPasses] = useState([])
    // The guest's dining credit, straight from the bootstrap. `null` means "not a member, or their
    // credit is switched off" — the server collapses both into null on purpose, so a credit figure
    // never reaches someone who cannot spend it. The header and the dining page read this same
    // object, so the nav entry and the page can never disagree about who has access.
    const [dining, setDining] = useState(null)

    return (
        <SellerPageContext.Provider
            value={{
                accountContext: { account, setAccount },
                eventContext: { events, setEvents },
                subscriptionContext: { subscriptions, setSubscriptions, entryPasses, setEntryPasses },
                diningContext: { dining, setDining },
                endUserContext: { endUser, setEndUser, purchasedSubscriptions, setPurchasedSubscriptions, purchasedEvents, setPurchasedEvents, triggerEndUserDataFetch, setTriggerEndUserDataFetch, fetchingEndUserData, setFetchingEndUserData },
            }}
        >
            {children}
        </SellerPageContext.Provider>
    );
}


export const useSellerPageContext = () => {
    const context = useContext(SellerPageContext);

    if (!context) throw new Error('useSellerPageContext context must be use inside SellerPageContextProvider');

    return context;
};
